import {Institution} from "../../models/institution.model";
import {NavigationMenu} from "../../models/navigation-menu/navigation-menu.model";
import {LayoutUser} from "../../models/layout-window.model";
import {SubscriptionStudyPrograms} from "../../models/subscription-study-programs.model";

export class UserSessionService {
    /* @ngInject */
    constructor() {
        //nothing yet
    }

    static storageKeys = {
        districtMode: "testprep.districtmode",
        districtTenantId: "testprep.districtid",
        currentSchool: "testprep.school",
        subscriptionStudyPrograms: "testprep.subscriptionStudyPrograms",
        tenantManagingDefaults: "testprep.tenantManagingDefaults",
        welcomeModal: "testprep.welcomeModal",
        navigationMenu: "testprep.navigationMenu",
        layoutUser: "testprep.layoutUser"
    };

    setDistrictMode(tenantId: string, district: boolean): void {
        if (district) {
            sessionStorage.setItem(UserSessionService.storageKeys.districtMode, "Y");
            sessionStorage.setItem(UserSessionService.storageKeys.districtTenantId, tenantId);
        } else {
            sessionStorage.removeItem(UserSessionService.storageKeys.districtMode);
            sessionStorage.removeItem(UserSessionService.storageKeys.districtTenantId);
            sessionStorage.removeItem(UserSessionService.storageKeys.currentSchool);
        }
    }

    isDistrictMode(): boolean {
        return sessionStorage.getItem(UserSessionService.storageKeys.districtMode) != null;
    }
    
    getDistrictTenantId(): string {
        return sessionStorage.getItem(UserSessionService.storageKeys.districtTenantId);
    }
    
    setCurrentSchool(institution: Institution): void {
        if (!institution) {
            sessionStorage.removeItem(UserSessionService.storageKeys.currentSchool);
        } else {
            sessionStorage.setItem(UserSessionService.storageKeys.currentSchool, JSON.stringify(institution));
        }
    } 
    
    hasCurrentSchool(): boolean {
        return sessionStorage.getItem(UserSessionService.storageKeys.currentSchool) != null;
    }

    getCurrentSchool(): Institution {
        let curentSchool: any = sessionStorage.getItem(UserSessionService.storageKeys.currentSchool);
        if (curentSchool != null) {
           return JSON.parse(curentSchool);
        } else {
            return null;
        }
    }

    setTenantManagingDefaults(value: boolean): void {
        sessionStorage.removeItem(UserSessionService.storageKeys.tenantManagingDefaults);
        if (value) {
            sessionStorage.setItem(UserSessionService.storageKeys.tenantManagingDefaults, "Y");
        }
    }

    isTenantManagingDefaults(): boolean {
        return !!sessionStorage.getItem(UserSessionService.storageKeys.tenantManagingDefaults);
    }

    setSubscriptionStudyPrograms(subscriptionStudyPrograms: SubscriptionStudyPrograms): void {
        sessionStorage.setItem(UserSessionService.storageKeys.subscriptionStudyPrograms, JSON.stringify(subscriptionStudyPrograms));
    }

    getSubscriptionStudyPrograms(): SubscriptionStudyPrograms {
        let subscriptionStudyPrograms: any = sessionStorage.getItem(UserSessionService.storageKeys.subscriptionStudyPrograms);
        if(subscriptionStudyPrograms != null) {
            return JSON.parse(subscriptionStudyPrograms);
        }

        return null;
    }

    setHideWelcomeModal(): void {
        sessionStorage.setItem(UserSessionService.storageKeys.welcomeModal, "hide");
    }

    showWelcomeModal(): boolean { 
        return !sessionStorage.getItem(UserSessionService.storageKeys.welcomeModal);
    }

    setNavigationMenu(navigationMenu: NavigationMenu) {
        sessionStorage.setItem(UserSessionService.storageKeys.navigationMenu, JSON.stringify(navigationMenu));
    }

    getNavigationMenu() {
        let currentMenu: any = sessionStorage.getItem(UserSessionService.storageKeys.navigationMenu);
        if (currentMenu != null) {
            return JSON.parse(currentMenu);            
        } else {
            return null;
        }
    }

    setLayoutUser(layoutUser: LayoutUser) {
        sessionStorage.setItem(UserSessionService.storageKeys.layoutUser, JSON.stringify(layoutUser));
    }

    getLayoutUser() {
        let layoutUser: any = sessionStorage.getItem(UserSessionService.storageKeys.layoutUser);
        if (layoutUser != null) {
            return JSON.parse(layoutUser);            
        } else {
            return null;
        }
    }    
}


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/user-session/user-session.service.ts
 **/